export const ecosystemSlug = 'LOBEES';
